<template>
    <v-layout justify-center>
        <v-responsive max-width="480" width="100%" class="px-3 mx-n3">
            <!-- <list-heading title="해시태그 설정" /> -->
            <div>카테고리 설정</div>

            <v-card outlined v-bind="{ loading }">
                <v-card-text class="py-3">
                    <template v-if="setting">
                        <v-combobox v-model="setting.datas.categories" multiple chips hide-details outlined append-icon="" />
                    </template>
                    <template v-else>
                        <v-skeleton-loader type="image" />
                    </template>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="primary" v-bind="{ loading }" @click="save">저장</v-btn>
                </v-card-actions>
            </v-card>
        </v-responsive>
    </v-layout>
</template>
<script>
import api from "@/api";

export default {
    data: () => ({
        setting: undefined,

        loading: false,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                var { setting } = await api.console.setting.get();
                this.setting = setting;
            } finally {
                this.loading = false;
            }
        },

        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const setting = JSON.parse(JSON.stringify(this.setting));
                await api.console.setting.put(setting);

                alert("저장되었습니다.");
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>